import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import AdminHeader from '@admin/components/layout/AdminHeader';
import AdminFooter from '@admin/components/layout/AdminFooter';

const AdminLayout = observer(() => {
    return (
        <div className='flex flex-col min-h-screen bg-[#F1F1F1]'>
            <AdminHeader />
            <main className='flex-grow container mx-auto p-4 text-break'>
                <Outlet />
            </main>
            <AdminFooter />
        </div>
    );
});

export default AdminLayout;
